export default "__VITE_ASSET__CZnEXZyU__"